<!--The content below is only a placeholder and can be replaced.-->
<div>
    <router-outlet></router-outlet>
</div>
